import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import html2pdf from 'html2pdf.js/dist/html2pdf.bundle.js';

// Fonction pour filtrer les images depuis les documents
function getImageFiles() {
  if (typeof WPData === 'undefined' || !WPData.postDocuments) {
    return [];
  }
  
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
  return WPData.postDocuments.filter(file => {
    const extension = file.name.split('.').pop().toLowerCase();
    return imageExtensions.includes(extension);
  });
}

// Fonction pour charger une image et la convertir en données utilisables par jsPDF
function loadImageAsDataURL(imageUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = function() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      canvas.width = img.width;
      canvas.height = img.height;
      
      ctx.drawImage(img, 0, 0);
      
      try {
        const dataURL = canvas.toDataURL('image/jpeg', 0.85);
        resolve({
          dataURL: dataURL,
          width: img.width,
          height: img.height
        });
      } catch (error) {
        reject(error);
      }
    };
    
    img.onerror = function() {
      reject(new Error('Impossible de charger l\'image'));
    };
    
    img.src = imageUrl;
  });
}

const optionsHtml2Pdf = {
  margin: 10,
  filename: 'document.pdf',
  image: { type: 'jpeg', quality: 0.98 },
  html2canvas: { scale: 2, useCORS: true, scrollY: 0 },
  jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
};

async function generatePDF() {
  // const fullContent = document.getElementById('content-to-pdf');
  // if (!fullContent) return;

  // // Cloner la première page
  // const clone = fullContent.cloneNode(true);
  // const blocksToRemove = clone.querySelectorAll('.block-with-table, .final, .pdf-pied-page');
  // blocksToRemove.forEach(el => el.remove());


  // // NOUVEAU : Mesurer la hauteur du contenu HTML
  // // Créer un élément temporaire pour mesurer
  // const tempDiv = document.createElement('div');
  // tempDiv.style.position = 'absolute';
  // tempDiv.style.visibility = 'hidden';
  // tempDiv.style.width = '210mm'; // Largeur A4
  // tempDiv.appendChild(clone);
  // document.body.appendChild(tempDiv);
  
  // const htmlHeightPx = tempDiv.offsetHeight;
  // document.body.removeChild(tempDiv);
  
  // // Convertir pixels en mm (approximation: 96 DPI)
  // const htmlHeightMm = (htmlHeightPx * 25.4) / 96;


  // const marginTopTablePages = 20;

  // // Générer la première page
  // const worker = html2pdf().set(optionsHtml2Pdf).from(clone).toPdf();
  // const pdf = await worker.get('pdf');

  // const pageHeight = pdf.internal.pageSize.getHeight();
  // const pageWidth = pdf.internal.pageSize.getWidth();
  // const margin = 10;
  // let cursorY = margin;

  // // Ajouter une page après la première page
  // pdf.addPage();
  // // cursorY = margin; 
  //     cursorY = marginTopTablePages;


  // const blocks = fullContent.querySelectorAll('.block-with-table');
  const fullContent = document.getElementById('content-to-pdf');
  if (!fullContent) return;

  // Cloner la première page
  const clone = fullContent.cloneNode(true);
  const blocksToRemove = clone.querySelectorAll('.block-with-table, .final, .pdf-pied-page');
  blocksToRemove.forEach(el => el.remove());

  // NOUVEAU : Mesurer la hauteur du contenu HTML
  // Créer un élément temporaire pour mesurer
  const tempDiv = document.createElement('div');
  tempDiv.style.position = 'absolute';
  tempDiv.style.visibility = 'hidden';
  tempDiv.style.width = '210mm'; // Largeur A4
  tempDiv.appendChild(clone);
  document.body.appendChild(tempDiv);
  
  const htmlHeightPx = tempDiv.offsetHeight;
  document.body.removeChild(tempDiv);
  
  // Convertir pixels en mm (approximation: 96 DPI)
  const htmlHeightMm = (htmlHeightPx * 25.4) / 96;

  const marginTopTablePages = 20;

  // Générer la première page
  const worker = html2pdf().set(optionsHtml2Pdf).from(clone).toPdf();
  const pdf = await worker.get('pdf');

  const pageHeight = pdf.internal.pageSize.getHeight();
  const pageWidth = pdf.internal.pageSize.getWidth();
  const margin = 10;
  
  // CALCULER l'espace restant sur la première page
  const usedSpace = htmlHeightMm + margin; // Hauteur du contenu + marge
  const remainingSpace = pageHeight - usedSpace - margin;
  
  // Décider si on ajoute une page ou si on continue sur la première
  let cursorY;
  if (remainingSpace < 30) { // Seuil minimum (30mm) pour ajouter du contenu
    pdf.addPage();
    cursorY = marginTopTablePages;
  } else {
    cursorY = usedSpace + 15; // Continuer sur la première page avec un petit espacement
  }

  const blocks = fullContent.querySelectorAll('.block-with-table');

  for (const block of blocks) {
    const extraSpacingBetweenBlocks = 8;
    let estimatedHeight = 0;
    estimatedHeight += 7; // titre
    estimatedHeight += 6; // sous-titre

    const table = block.querySelector('table.auto-table');
    let tempPdf = new jsPDF();
    autoTable(tempPdf, {
      html: table,
      startY: 0,
      margin: { left: margin, right: margin },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        fillColor: [215, 236, 242],
        textColor: [12, 74, 110], // ← Couleur du texte d'en-tête
      },
      bodyStyles: {
        textColor: [12, 74, 110] // ← Couleur du texte du corps
      },
      styles: { lineColor: [12, 74, 110] }
    });
    estimatedHeight += tempPdf.lastAutoTable.finalY + 10;

    const afterTable = block.querySelector('p:not(.uppercase)');
    if (afterTable) {
      estimatedHeight += 6;
    }

    if (cursorY + estimatedHeight > pageHeight - margin) {
      pdf.addPage();
      cursorY = marginTopTablePages;
    }

    // Titre
    const h2 = block.querySelector('h2');
    if (h2) {
      pdf.setFontSize(14);
      pdf.setTextColor('#1199bc');
      pdf.text(h2.innerText, margin, cursorY);
      cursorY += 7;
    }

    // Sous-titre
    const subtitle = block.querySelector('p.uppercase');
    if (subtitle) {
      pdf.setFontSize(11);
      pdf.setTextColor('#125772');
      pdf.text(subtitle.innerText, margin, cursorY);
      cursorY += 6;
    }

    // Tableau
    autoTable(pdf, {
      html: table,
      startY: cursorY,
      margin: { left: margin, right: margin },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        fillColor: [215, 236, 242],
        textColor: [12, 74, 110], // ← Couleur du texte d'en-tête
      },
      bodyStyles: {
        textColor: [12, 74, 110] // ← Couleur du texte du corps
      },
      styles: { lineColor: [12, 74, 110] }
    });
    cursorY = pdf.lastAutoTable.finalY + 10;

    // Texte après tableau
    if (afterTable) {
      if (cursorY + 6 > pageHeight - margin) {
        pdf.addPage();
        cursorY = marginTopTablePages;
      }
      pdf.setFontSize(10);
      pdf.setTextColor('#125772');
      pdf.text(afterTable.innerText, margin, cursorY);
      cursorY += 6;
    }
    cursorY += extraSpacingBetweenBlocks;
  }

  // // Bloc final
  // const finalBlock = fullContent.querySelector('.final');
  // if (finalBlock) {
  //   const safeAreaHeight = 50;
  //   const desc = finalBlock.querySelector('#final-desc');
  //   const flexDivs = finalBlock.querySelectorAll('.flex > div');

  //   // Estimer la hauteur totale du bloc final
  //   let estimatedFinalBlockHeight = 0;

  //   // Description principale
  //   if (desc) {
  //     const text = desc.innerText;
  //     const maxWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
  //     const lines = pdf.splitTextToSize(text, maxWidth);

  //     if (cursorY + lines.length * 5 > pageHeight - margin) {
  //       pdf.addPage();
  //       cursorY = margin;
  //     }

  //     pdf.setFontSize(10);
  //     pdf.text(lines, margin, cursorY);
  //     cursorY += lines.length * 5 + 5;
  //   }

  //   // Les deux colonnes
  //   if (flexDivs.length === 2) {
  //     const left = Array.from(flexDivs[0].querySelectorAll('p')).map(p => p.innerText);
  //     const right = Array.from(flexDivs[1].querySelectorAll('p')).map(p => p.innerText);

  //     const halfWidth = (pdf.internal.pageSize.getWidth() - 2 * margin) / 2;

  //     let maxLines = Math.max(left.length, right.length);
  //     if (cursorY + maxLines * 5 > pageHeight - margin) {
  //       pdf.addPage();
  //       cursorY = margin;
  //     }

  //     let offsetY = cursorY;
  //     left.forEach(line => {
  //       pdf.text(line, margin, offsetY);
  //       offsetY += 5;
  //     });

  //     offsetY = cursorY;
  //     right.forEach(line => {
  //       pdf.text(line, margin + halfWidth + 10, offsetY);
  //       offsetY += 5;
  //     });

  //     cursorY += maxLines * 5 + 5;
  //   }
  // }

  // Bloc final
  const finalBlock = fullContent.querySelector('.final');
  if (finalBlock) {
    const safeAreaHeight = 50; // Hauteur minimale requise en mm (ajuste selon tes besoins)
    
    const desc = finalBlock.querySelector('#final-desc');
    const flexDivs = finalBlock.querySelectorAll('.flex > div');

    // Estimer la hauteur totale du bloc final
    let estimatedFinalBlockHeight = 0;
    
    if (desc) {
      const text = desc.innerText;
      const maxWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
      const lines = pdf.splitTextToSize(text, maxWidth);
      estimatedFinalBlockHeight += lines.length * 5 + 5;
    }
    
    if (flexDivs.length === 2) {
      const left = Array.from(flexDivs[0].querySelectorAll('p')).map(p => p.innerText);
      const right = Array.from(flexDivs[1].querySelectorAll('p')).map(p => p.innerText);
      const maxLines = Math.max(left.length, right.length);
      estimatedFinalBlockHeight += maxLines * 5 + 5;
    }
    
    // Vérifier si le bloc + safe area rentrent sur la page actuelle
    if (cursorY + estimatedFinalBlockHeight + safeAreaHeight > pageHeight - margin) {
      pdf.addPage();
      cursorY = margin;
    }

    // Description principale
    if (desc) {
      const text = desc.innerText;
      const maxWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
      const lines = pdf.splitTextToSize(text, maxWidth);

      pdf.setFontSize(10);
      pdf.setTextColor('#125772');
      pdf.text(lines, margin, cursorY);
      cursorY += lines.length * 5 + 5;
    }

    // Les deux colonnes
    if (flexDivs.length === 2) {
      const left = Array.from(flexDivs[0].querySelectorAll('p')).map(p => p.innerText);
      const right = Array.from(flexDivs[1].querySelectorAll('p')).map(p => p.innerText);

      const halfWidth = (pdf.internal.pageSize.getWidth() - 2 * margin) / 2;
      let maxLines = Math.max(left.length, right.length);

      let offsetY = cursorY;
      left.forEach(line => {
        pdf.text(line, margin, offsetY);
        offsetY += 5;
      });

      offsetY = cursorY;
      right.forEach(line => {
        pdf.text(line, margin + halfWidth + 10, offsetY);
        offsetY += 5;
      });

      cursorY += maxLines * 5 + 5;
    }
  }

  // Pied de page sur chaque page
  const footerBlock = document.querySelector('.pdf-pied-page');
  let footerLines = [];
  if (footerBlock) {
    footerLines = Array.from(footerBlock.querySelectorAll('p')).map(p => p.innerText);
  }

  // Ajouter les images en annexe
  await addImagePages(pdf, pageHeight, pageWidth, margin, footerLines);

  // Appliquer le pied de page à toutes les pages (y compris celles avec les images)
  const finalPageCount = pdf.internal.getNumberOfPages();

  for (let i = 1; i <= finalPageCount; i++) {
    pdf.setPage(i);

    let offsetY = pageHeight - 10 - (footerLines.length - 1) * 5;

    footerLines.forEach(line => {
      const textWidth = pdf.getTextWidth(line);
      const x = (pageWidth - textWidth) / 2;
      pdf.setFontSize(8);
      pdf.setTextColor('#125772');
      pdf.text(line, x, offsetY);
      offsetY += 5;
    });
  }

  // Télécharger
  pdf.save();
}

// Fonction pour ajouter les pages d'images
async function addImagePages(pdf, pageHeight, pageWidth, margin, footerLines) {
  const imageFiles = getImageFiles();
  
  if (imageFiles.length === 0) {
    return; // Pas d'images à ajouter
  }

  for (const imageFile of imageFiles) {
    try {
      // Charger l'image
      const imageData = await loadImageAsDataURL(imageFile.url);
      
      // Ajouter une nouvelle page
      pdf.addPage();
      
      // Titre avec nom du fichier
      // pdf.setFontSize(14);
      // pdf.text(imageFile.name, margin, margin + 10);
      
      // Calculer les dimensions pour s'adapter à la page
      const availableWidth = pageWidth - (2 * margin);
      const availableHeight = pageHeight - (2 * margin) - 20 - (footerLines.length * 5) - 10; // Espace pour titre et footer
      
      let imgWidth = imageData.width;
      let imgHeight = imageData.height;
      
      // Redimensionner si nécessaire pour tenir dans la page
      const widthRatio = availableWidth / imgWidth;
      const heightRatio = availableHeight / imgHeight;
      const ratio = Math.min(widthRatio, heightRatio, 1); // Ne pas agrandir
      
      imgWidth = imgWidth * ratio;
      imgHeight = imgHeight * ratio;
      
      // Centrer l'image
      const x = (pageWidth - imgWidth) / 2;
      const y = margin + 20; // Espace après le titre
      
      // Ajouter l'image au PDF
      pdf.addImage(imageData.dataURL, 'JPEG', x, y, imgWidth, imgHeight);
      
    } catch (error) {
      console.error('Erreur lors du chargement de l\'image:', imageFile.name, error);
      
      // Ajouter une page avec message d'erreur
      pdf.addPage();
      pdf.setFontSize(14);
      pdf.setTextColor('#125772');
      pdf.text(imageFile.name, margin, margin + 10);
      pdf.setFontSize(10);
      pdf.setTextColor('#125772');
      pdf.text('Erreur: Impossible de charger cette image', margin, margin + 25);
    }
  }
}

// Bouton
const btn = document.getElementById('download-pdf');
if (btn) {
  btn.addEventListener('click', generatePDF);
}